import { SET_ROUTES_CONFIG } from './actions';
import { setRoutesConfigAction } from './types';

const initialState = {};

export const routesConfigReducer = (
  state = initialState,
  action: setRoutesConfigAction,
) => {
  switch (action.type) {
    case SET_ROUTES_CONFIG:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
